import React, { useEffect, useState, useContext, useRef } from "react";
import { BsSearch } from "react-icons/bs";
import { BsCart2 } from "react-icons/bs";
import ShopNavbar from "./StoreComponents/ShopNavbar";
import StoreFooter from "./StoreComponents/StoreFooter";
import { Link, useLocation } from "react-router-dom";
import { userProvider } from "../../contexts/UserContext";
import LoadingSpinner from "../../components/utils/LoadingSpinner";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { domainProvider } from "../../contexts/DomainContext";
import axios from "axios";
import "./style.css"
import Div from "../../components/utils/Div";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [dummyProducts, setDummyProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isVendor } = useContext(userProvider);
  const [range, setRange] = useState(0);
  const [categories, setCategories] = useState([]);
  const [colors, setColors] = useState([]);
  const [dbTags, setdbTags] = useState([]);
  const [dbSizes, setdbSizes] = useState([]);
  const [productHead, setProducthead] = useState(false);
  const { state } = useLocation();
  const selectLanguage = i18next.language;
  const { t } = useTranslation();
  const storeName = window.location.href.split("/")[3];

  // custom domain
  const { customdomain, titleName } = useContext(domainProvider);
  console.log(state?.searchValue, "value");


  useEffect(() => {
    const getAllProducts = async () => {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallproducts/${storeName}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallproducts`,
          {
            headers: {
              domain_name: customdomain,
              "Content-Type": "application/json",
            },
          }
        );
      }
      const response = await res.data;
      if (response.status_code === 200 && response.data) {
        setProducts(response.data);
        setAllProducts(response.data);
      }
      if (response.status_code === 200 && response.dummyData)
        setDummyProducts(response.dummyData);
      setLoading(false);
    };


    const getAllCategories = async () => {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstorecategory/${storeName}`
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstorecategory`,
          {
            headers: {
              domain_name: customdomain,
            },
          }
        );
      }
      const response = await res.data;
      if (response.data) {
        const categoryData = response.data.map((category) => {
          const obj = {
            name:
              selectLanguage === "ar" && category.category_name_ar
                ? category.category_name_ar
                : category.category_name,
            value: category.category_id,
          };
          return obj;
        });

        setCategories(categoryData);
      } else {
        setCategories([]);
      }
    };

    const getAllColors = async () => {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstorecolor/${storeName}`
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstorecolor`,
          {
            headers: {
              domain_name: customdomain,
            },
          }
        );
      }
      const response = await res.data;
      if (response.data) {
        setColors(response.data);
      }
    };

    const getAllTags = async () => {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstoretag/${storeName}`
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstoretag`,
          {
            headers: {
              domain_name: customdomain,
            },
          }
        );
      }
      const response = await res.data;
      if (response.data) {
        const allData = response.data.map((tag) => {
          const obj = {
            label:
              selectLanguage === "ar" && tag.tag_name_ar
                ? tag.tag_name_ar
                : tag.tag_name,
            value: tag.tag_id,
          };
          return obj;
        });

        setdbTags(allData);
      }
    };

    const getAllSize = async () => {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstoresize/${storeName}`
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallstoresize`,
          {
            headers: {
              domain_name: customdomain,
            },
          }
        );
      }
      const response = await res.data;
      if (response.data) {
        const allData = response.data.map((size) => {
          const obj = {
            label:
              selectLanguage === "ar" && size.size_name_ar
                ? size.size_name_ar
                : size.size_name,
            value: size.size_id,
          };
          return obj;
        });
        setdbSizes(allData);
      }
    };

    getAllProducts();

    getAllCategories();
    getAllColors();
    getAllTags();
    getAllSize();

  }, [customdomain, selectLanguage]);
  const getBySearch = async () => {
    var res;
    if (customdomain === "aitech.com.sa") {
      res = await axios.get(
        `${process.env.REACT_APP_APIURL}/vendor/store/searchitems/${storeName}?search_term=${state?.searchValue}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } else {
      await axios.get(
        `${process.env.REACT_APP_APIURL}/vendor/store/searchitems?search_term=${state?.searchValue}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
    const response = await res?.data;
    if (response) {
      if (response.status_code === 200 && response.data) {
        setProducts(response.data);
        setAllProducts(response.data);
      }
    }
  };

  useEffect(() => {
    if (state?.searchValue) {
      getBySearch();
    }
  }, [state?.searchValue])

  console.log(allProducts, "a");


  // this for search
  const handleToSearch = async (e) => {
    e.preventDefault();
    const form = e.target;
    const value = form.value.value;
    var res;
    if (customdomain === "aitech.com.sa") {
      res = await axios.get(
        `${process.env.REACT_APP_APIURL}/vendor/store/searchitems/${storeName}?search_term=${state?.searchValue}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } else {
      res = await axios.get(
        `${process.env.REACT_APP_APIURL}/vendor/store/searchitems?search_term=${state?.searchValue}`,
        {
          headers: {
            "Content-Type": "application/json",
            domain_name: customdomain,
          },
        }
      );
    }
    const response = await res.data;
    if (response) {
      if (response.status_code === 200 && response.data) {
        setProducts(response.data);
        setAllProducts(response.data);
      } else {
        toast.error(response.message);
        setProducts(null);
        setAllProducts(null);
        form.reset();
      }
    }
  };

  // this section for select color
  const [productColor, setProductColor] = useState({
    colors: [],
    store: [],
  });
  const handleColorChange = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    const { colors } = productColor;

    // Case 1 : The user checks the box
    if (checked) {
      setProductColor({
        colors: [...colors, value],
        store: [...colors, value],
      });
    }

    // Case 2 : The user unchecks the box
    else {
      setProductColor({
        colors: colors.filter((e) => e !== value),
        store: colors.filter((e) => e !== value),
      });
    }
  };

  // this is for category selector
  const [productCategory, setProductCategory] = useState({
    category: [],
    store: [],
  });
  const handleProductCategoryChange = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    const { category } = productCategory;

    // Case 1 : The user checks the box
    if (checked) {
      setProductCategory({
        category: [...category, value],
        store: [...category, value],
      });
    }
    // Case 2  : The user unchecks the box
    else {
      setProductCategory({
        category: category.filter((e) => e !== value),
        store: category.filter((e) => e !== value),
      });
    }
  };

  // this is for Tags selector
  const [productTags, setProductTags] = useState({
    tags: [],
    store: [],
  });
  const handleProductTagsChange = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    const { tags } = productTags;

    // Case 1 : The user checks the box
    if (checked) {
      setProductTags({
        tags: [...tags, value],
        store: [...tags, value],
      });
    }
    // Case 2  : The user unchecks the box
    else {
      setProductTags({
        tags: tags.filter((e) => e !== value),
        store: tags.filter((e) => e !== value),
      });
    }
  };

  const [productSize, setProductSize] = useState({
    size: [],
    store: [],
  });

  const handleProductSizeChange = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    const { size } = productSize;
    // Case 1 : The user checks the box
    if (checked) {
      setProductSize({
        size: [...size, value],
        store: [...size, value],
      });
    }
    // Case 2  : The user unchecks the box
    else {
      setProductSize({
        size: size.filter((e) => e !== value),
        store: size.filter((e) => e !== value),
      });
    }
  };

  const handleRange = (e) => {
    const dataRange = e * 100;
    setRange(dataRange);
  };

  const handleToFilter = async ({ type }) => {
    let amount = 0;
    if (range !== 0) {
      amount = range;
    } else {
      amount = 10000;
    }
    const category = productCategory.store.toString() || "";
    const color = productColor.store.toString() || "";
    const size = productSize.store.toString() || "";
    const tag = productTags.store.toString() || "";
    if (type === "filter") {
      var res;
      if (customdomain === "aitech.com.sa") {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/getallproducts/${storeName}?amount=${amount}&category=${category}&size=${size}&color=${color}&tag=${tag}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store?amount=${amount}&category=${category}&size=${size}&color=${color}&tag=${tag}`,
          {
            headers: {
              "Content-Type": "application/json",
              domain_name: customdomain,
            },
          }
        );
      }
      const response = await res.data;
      if (response) {
        if (response.status_code === 200) {
          if (response.data) {
            setProducts(response.data);
            setAllProducts(response.data);
          }
          // else if (response?.dummyData?.length === 0) {
          //   setDummyProducts(null);
          //   toast.info(response.message);
          // }
          // else if (response.dummyData.length > 0) {
          //   setDummyProducts(response.dummyData);
          //   toast.info(response.message);
          // }
          else {
            setProducthead(true);
            toast.error(response.message);
            setProducts(null);
            setAllProducts(null);
            setDummyProducts(null);
          }
        }
      }
    } else if (type === "reset") {
      handleResetActive();
      const getAllProducts = async () => {
        var res;
        if (customdomain === "aitech.com.sa") {
          res = await axios.get(
            `${process.env.REACT_APP_APIURL}/vendor/store/getallproducts/${storeName}`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } else {
          res = await axios.get(
            `${process.env.REACT_APP_APIURL}/vendor/store/getallproducts`,
            {
              headers: {
                "Content-Type": "application/json",
                domain_name: customdomain,
              },
            }
          );
        }
        const response = await res.data;
        if (response.status_code === 200) {
          setProducts(response?.data ? response?.data : []);
          setAllProducts(response?.data ? response?.data : []);
          setDummyProducts(response?.dummyData);
        }
        //  else if (response.status_code === 200 && response.dummyData) {
        //   setDummyProducts(response.dummyData);
        //   toast.info(response.message);
        // }
        setLoading(false);
      };
      getAllProducts();
      // reset all selected filters
      setProductCategory({ category: [], store: [] });
      setProductTags({ tags: [], store: [] });
      setProductSize({ size: [], store: [] });
      setProductColor({ colors: [], store: [] });
    }
  };

  // to show active option
  function handleActive(index, type, dim) {
    var options;
    if (type === "category")
      options = document.getElementsByClassName("categories");
    else if (type === "color")
      options = document.getElementsByClassName("colors");
    else if (type === "size")
      options = document.getElementsByClassName("sizes");
    else if (type === "tag") options = document.getElementsByClassName("tags");

    if (dim === "desktop") {
      index += options.length / 2;
    }

    for (var i = 0; i < options.length; i++) {
      if (i == index) {
        if (type === "tag") {
          if (options[i].style.color === "rgb(255, 255, 255)") {
            options[i].style.color = "#575757";
            options[i].style.backgroundColor = "#fff";
          } else {
            options[i].style.color = "#fff";
            options[i].style.backgroundColor = "#f4900c";
          }
        } else {
          if (options[i].style.color === "rgb(244, 144, 12)")
            options[i].style.color = "#575757";
          else options[i].style.color = "#f4900c";
        }
      }
      // } else {
      //   options[i].style.color = "#575757";
      // }
    }
  }

  function handleResetActive() {
    var cats = document.getElementsByClassName("categories");
    var cols = document.getElementsByClassName("colors");
    var sizes = document.getElementsByClassName("sizes");
    var tags = document.getElementsByClassName("tags");

    for (var i = 0; i < cats.length; i++) cats[i].style.color = "#575757";

    for (var i = 0; i < cols.length; i++) cols[i].style.color = "#575757";

    for (var i = 0; i < sizes.length; i++) sizes[i].style.color = "#575757";

    for (var i = 0; i < tags.length; i++) {
      tags[i].style.color = "#575757";
      tags[i].style.backgroundColor = "#fff";
    }
  }

  const [isOpen, setIsOpen] = useState(false);
  const drawerRef = useRef(null);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(event.target) &&
        isOpen
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div className="flex flex-col min-h-[100vh]">
        <ShopNavbar />
        <Helmet>
          <title>Shop - {titleName}</title>
        </Helmet>
        <Div>
          <div className="relative pt-8" style={{ flexGrow: 1 }}>
            <div>
              {/* Mobile Sidebar */}
              <div
                className={`${isOpen ? "translate-x-0" : "-translate-x-full"
                  } fixed top-0 left-0 h-full w-72 bg-white z-50 p-6 shadow-xl transition-all duration-300 ease-in-out`}
                ref={drawerRef}
              >
                <div className="block md:hidden">
                  {/* Search Bar */}
                  <form onSubmit={handleToSearch} className="relative mb-8">
                    <input
                      type="text"
                      name="value"
                      placeholder="Search Products..."
                      className="w-full bg-gray-50 px-5 py-3 rounded-full text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300"
                      aria-label="Search products"
                    />
                    <button
                      type="submit"
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary/50 rounded-full p-1"
                      aria-label="Submit search"
                    >
                      <BsSearch className="text-lg" />
                    </button>
                  </form>

                  {/* Price Range */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">{t("Filter by price")}</h2>
                    <input
                      type="range"
                      min="0"
                      max="100"
                      className="w-full h-1 bg-gray-200 rounded-full cursor-pointer accent-primary focus:outline-none focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => handleRange(e.target.value)}
                      aria-label="Price range filter"
                    />
                    <p className="mt-3 text-sm text-gray-600">
                      <span className="font-medium">{t("add_new_product_price")}:</span> 0 ر.س {range || "All"} ر.س
                    </p>
                    <div className="mt-4 flex gap-4">
                      <button
                        onClick={() => handleToFilter({ type: "filter" })}
                        className="bg-primary text-white text-sm px-5 py-2.5 rounded-lg hover:bg-primary/85 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                      >
                        {t("Filter")}
                      </button>
                      <button
                        onClick={() => handleToFilter({ type: "reset" })}
                        className="bg-orange-500 text-white text-sm px-5 py-2.5 rounded-lg hover:bg-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400/50 transition-all duration-300"
                      >
                        {t("Reset")}
                      </button>
                    </div>
                  </div>

                  {/* Filter by Color */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">{t("Filter by color")}</h2>
                    {colors.length > 0 ? (
                      colors.map((color, idx) => (
                        <div key={idx} className="flex items-center gap-3 mb-2">
                          <input
                            type="checkbox"
                            value={color.color_id}
                            id={color.color_name}
                            onChange={handleColorChange}
                          />
                          <label
                            htmlFor={color.color_name}
                            onClick={() => handleActive(idx, "color", "mobile")}
                            className="flex items-center gap-2 cursor-pointer text-sm text-gray-700 hover:text-primary transition-colors duration-200"
                          >
                            {selectLanguage === "ar" && color.color_name_ar
                              ? color.color_name_ar.length > 10
                                ? color.color_name_ar.slice(0, 10) + "..."
                                : color.color_name_ar
                              : color.color_name.length > 10
                                ? color.color_name.slice(0, 10) + "..."
                                : color.color_name}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-400 text-sm">No data found</p>
                    )}
                  </div>

                  {/* Filter by Category */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">{t("add_new_product_Category")}</h2>
                    {categories.length > 0 ? (
                      categories.map((cat, idx) => (
                        <div key={idx} className="flex items-center gap-3 mb-2">
                          <input
                            type="checkbox"
                            value={cat.value}
                            id={cat.name}
                            onChange={handleProductCategoryChange}
                          />
                          <label
                            htmlFor={cat.name}
                            onClick={() => handleActive(idx, "category", "mobile")}
                            className="flex items-center gap-2 cursor-pointer text-sm text-gray-700 hover:text-primary transition-colors duration-200"
                          >
                            {cat.name.length > 10 ? cat.name.slice(0, 10) + "..." : cat.name}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-400 text-sm">No data found</p>
                    )}
                  </div>

                  {/* Filter by Size */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">
                      {t("all_product_dataTable1")} {t("add_new_product_Sizes")}
                    </h2>
                    {dbSizes.length > 0 ? (
                      dbSizes.map((size, idx) => (
                        <div key={idx} className="flex items-center gap-3 mb-2">
                          <input
                            type="checkbox"
                            value={size.value}
                            id={`size${size.value}`}
                            onChange={handleProductSizeChange}
                          />
                          <label
                            htmlFor={`size${size.value}`}
                            onClick={() => handleActive(idx, "size", "mobile")}
                            className="flex items-center gap-2 cursor-pointer text-sm text-gray-700 hover:text-primary transition-colors duration-200"
                          >
                            {size.label.length > 10 ? size.label.slice(0, 10) + "..." : size.label}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-400 text-sm">No data found</p>
                    )}
                  </div>

                  {/* Tags */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">{t("add_new_product_Tags")}</h2>
                    <div className="flex flex-wrap gap-2.5">
                      {dbTags.length > 0 ? (
                        dbTags.map((tag, idx) => (
                          <div key={idx}>
                            <input
                              type="checkbox"
                              value={tag.value}
                              id={`tags${tag.value}`}
                              onChange={handleProductTagsChange}
                              className="peer hidden"
                            />
                            <label
                              htmlFor={`tags${tag.value}`}
                              onClick={() => handleActive(idx, "tag", "mobile")}
                              className="inline-block px-4 py-1.5 rounded-full text-xs font-medium uppercase border border-gray-200 text-gray-700 peer-checked:bg-primary peer-checked:text-white peer-checked:border-primary hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary/50 cursor-pointer transition-all duration-300"
                            >
                              {tag.label.length > 10 ? tag.label.slice(0, 10) + "..." : tag.label}
                            </label>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-400 text-sm">No data found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {isOpen && (
                <div
                  className="fixed top-0 left-0 w-full bg-black opacity-50 z-40"
                  onClick={toggleDrawer}
                ></div>
              )}
            </div>

            <div className="Container mx-auto">
              <div className={`px-5 pt-4 block md:hidden`}>
                <p
                  onClick={toggleDrawer}
                  className="rounded-md btn btn-primary btn-sm text-white"
                >
                  {t("Filter")}
                </p>
              </div>
              <div className="shop_container px-5 py-5 relative">
                {/* sidebar in desktop view */}


                <div className="w-11/12 hidden md:block px-6 py-8 space-y-12 text-gray-800 bg-white shadow-equal">
                  {/* Search Bar */}
                  <form onSubmit={handleToSearch} className="relative md:hidden">
                    <input
                      type="text"
                      name="value"
                      placeholder="Search products..."
                      className="w-full bg-gray-50  px-5 py-3 rounded-full text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300"
                      aria-label="Search products"
                    />
                    <button
                      type="submit"
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary/50 rounded-full p-1"
                      aria-label="Submit search"
                    >
                      <BsSearch className="text-lg" />
                    </button>
                  </form>

                  {/* Price Range */}
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{t("Filter by price")}</h2>
                    <input
                      type="range"
                      min="0"
                      max="100"
                      className="w-full h-1 bg-gray-200 rounded-full cursor-pointer accent-primary focus:outline-none focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => handleRange(e.target.value)}
                      aria-label="Price range filter"
                    />
                    <p className="mt-3 text-sm text-gray-600">
                      <span className="font-medium">{t("add_new_product_price")}:</span> 0 ر.س {range || "All"} - ر.س
                    </p>
                    <div className="mt-4 flex gap-4">
                      <button
                        onClick={() => handleToFilter({ type: "filter" })}
                        className="bg-primary text-white text-sm px-5 py-2.5 rounded-lg hover:bg-primary/85 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                      >
                        {t("Filter")}
                      </button>
                      <button
                        onClick={() => handleToFilter({ type: "reset" })}
                        className="bg-orange-500 text-white text-sm px-5 py-2.5 rounded-lg hover:bg-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400/50 transition-all duration-300"
                      >
                        {t("Reset")}
                      </button>
                    </div>
                  </div>

                  {/* Reusable Filter Section */}
                  {[
                    { title: t("Filter by color"), items: colors, type: "color", nameKey: "color_name", arNameKey: "color_name_ar", handler: handleColorChange },
                    { title: t("add_new_product_Category"), items: categories, type: "category", nameKey: "name", handler: handleProductCategoryChange },
                    { title: `${t("all_product_dataTable1")} ${t("add_new_product_Sizes")}`, items: dbSizes, type: "size", nameKey: "label", handler: handleProductSizeChange },
                  ].map(({ title, items, type, nameKey, arNameKey, handler }, idx) => (
                    <div key={idx}>
                      <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
                      <div className="mt-3 space-y-2">
                        {items.length > 0 ? (
                          items.map((item, i) => {
                            const value = item.value || item.color_id;
                            const displayName = selectLanguage === "ar" ? item[arNameKey]?.slice(0, 10) : item[nameKey]?.slice(0, 10);

                            return (
                              <div key={i} className="flex items-center gap-3">
                                <input
                                  type="checkbox"
                                  id={`${type}${value}`}
                                  value={value}
                                  onChange={handler}
                                />
                                <label
                                  htmlFor={`${type}${value}`}
                                  onClick={() => handleActive(i, type, "desktop")}
                                  className="flex items-center gap-2 cursor-pointer text-sm text-gray-700 hover:text-primary transition-colors duration-200"
                                >
                                  {displayName}
                                  {item[nameKey]?.length > 10 && "..."}
                                </label>
                              </div>
                            );
                          })
                        ) : (
                          <p className="text-gray-400 text-sm">No data found</p>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Tags */}
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{t("add_new_product_Tags")}</h2>
                    <div className="flex flex-wrap gap-2.5">
                      {dbTags.length > 0 ? (
                        dbTags.map((tag, i) => (
                          <div key={i}>
                            <input
                              type="checkbox"
                              id={`tag${tag.value}`}
                              value={tag.value}
                              onChange={handleProductTagsChange}
                              className="peer hidden"
                            />
                            <label
                              htmlFor={`tag${tag.value}`}
                              onClick={() => handleActive(i, "tag", "desktop")}
                              className="inline-block px-4 py-1.5 rounded-full text-xs font-medium uppercase border border-gray-200 text-gray-700 peer-checked:bg-primary peer-checked:text-white peer-checked:border-primary hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary/50 cursor-pointer transition-all duration-300"
                            >
                              {tag.label.length > 10 ? tag.label.slice(0, 10) + "..." : tag.label}
                            </label>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-400 text-sm">No data found</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex justify-start pt-2 pb-5 mb-4">
                    <p>
                      {allProducts && allProducts.length > 0
                        ? selectLanguage === "ar"
                          ? `عرض الكل ${allProducts?.length} النتيجة `
                          : `Showing All ${allProducts?.length} Result`
                        : productHead
                          ? "Showing all 0 result"
                          : "Sample Products"}
                    </p>
                  </div>
                  {!allProducts && (
                    <div className="min-h-[50vh] flex justify-center items-center bg-white">
                      <p className="text-xl md:text-3xl font-semibold md:font-bold text-gray-600">
                        {selectLanguage === "ar"
                          ? "لا توجد منتجات تم العثور عليها"
                          : "No Product Found"}
                      </p>
                    </div>
                  )}

                  <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {allProducts?.map((item, idx) => {
                      const isArabic = selectLanguage === "ar";
                      const productName = isArabic && item.product_name_ar ? item.product_name_ar : item.product_name;
                      const productUrl = customdomain === "aitech.com.sa"
                        ? `/${storeName}/product_details/${item.product_id}`
                        : `/product_details/${item.product_id}`;

                      return (
                        <div
                          key={idx}
                          className="bg-white shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden w-full max-w-sm"
                        >
                          {/* Product Image */}
                          <Link to={productUrl} className="block w-full h-[200px] md:h-[280px] overflow-hidden">
                            <img
                              src={item.thumbnail_image}
                              alt={productName}
                              className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                            />
                          </Link>

                          {/* Content */}
                          <div className="p-4 flex flex-col items-center text-center">
                            <Link to={productUrl}>
                              <h2 className="text-gray-700 font-semibold text-lg line-clamp-2 hover:text-blue-600 transition-all">
                                {productName}
                              </h2>
                            </Link>

                            {/* Price & Add to Cart */}
                            <div className="mt-3 flex flex-col items-center gap-2">
                              <p className="text-primary text-base font-medium">
                                {item.product_price} ر.س
                              </p>
                              <Link
                                to={productUrl}
                                className="hover:text-white inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#F97316] text-white text-sm font-medium px-4 py-2 rounded-full transition"
                              >
                                <span className="hover:text-white flex">
                                  <BsCart2 className={isArabic ? "ml-2" : "mr-2"} />
                                  <span className="hidden md:block">   {isArabic ? "إضافة إلى السلة" : "Add to cart"}</span>
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>



                  {/* sample products */}
                  {allProducts?.length === 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 justify-items-center md:justify-items-start">
                      {dummyProducts?.map((item, idx) => (
                        <div
                          className="single_product relative cursor-pointer bg-gray-200 pb-4 shadow-sm rounded-sm hover:shadow-md hover:scale-[1.01] ease-linear duration-300 md:min-w-fit max-w-[360px] w-full align-self-center"
                          key={idx}
                        >
                          <div className="absolute top-0 right-0 p-3 bg-gray-200 hover:bg-black hover:text-primary heart ease-in-out transition-all duration-300">
                            <p>{item.product_price} ر.س</p>
                          </div>
                          <div className="w-full h-[320px]">
                            <Link
                              to={`${customdomain === "aitech.com.sa"
                                ? `/${storeName}/product_details/${item.product_id}`
                                : `/product_details/${item.product_id}`
                                }`}
                              className="text-center text-gray-400"
                            >
                              <img
                                className="w-full h-full object-cover"
                                src={item.thumbnail_image}
                                alt={
                                  selectLanguage == "ar" && item.product_name_ar
                                    ? item.product_name_ar
                                    : item.product_name
                                }
                              />
                            </Link>
                          </div>
                          <div className="">
                            <h2 className="card-title justify-center text-gray-400 hover:text-blue-500 text-[14px] my-3">
                              <Link
                                to={`${customdomain === "aitech.com.sa"
                                  ? `/${storeName}/product_details/${item.product_id}`
                                  : `/product_details/${item.product_id}`
                                  }`}
                                className="text-gray-600 text-base capitalize"
                              >
                                {selectLanguage == "ar" && item.product_name_ar
                                  ? item.product_name_ar
                                  : item.product_name}
                              </Link>
                            </h2>
                            <div className="card-actions justify-center items-center flex-col lg:overflow-hidden lg:h-[20px]">
                              <div className="price text-center">
                                <p>{item.product_price} ر.س</p>
                                <Link
                                  to={`${customdomain === "aitech.com.sa"
                                    ? `/${storeName}/product_details/${item.product_id}`
                                    : `/product_details/${item.product_id}`
                                    }`}
                                  className=" transition-all ease-in duration-300 text-blue-700 hover:text-blue-700 flex items-center "
                                >
                                  <BsCart2
                                    className={`inline mr-2 ${selectLanguage == "ar" ? "ml-3" : "ml-0"
                                      } `}
                                  />
                                  {selectLanguage == "ar"
                                    ? "إضافة إلى السلة"
                                    : "Add to cart"}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Div>
        <StoreFooter />
      </div>
    </>
  );
};

export default Shop;
